import { createDownloadableLink } from '../../../helpers';
import { FORMAT_DD_MM_YYYY } from '../../company/constants';
import { formatUTCDate } from '@/helpers';
import moment from 'moment';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),

  getData:
    (search, paging, filterOption = {}, sortOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().resultsReviewBackroom.paging;
      let { result, status } = await Api.post(`fut-backrooms/test-reviews`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
        fromDate: filterOption?.fromDate
          ? formatUTCDate(filterOption?.fromDate, { isStarOfDay: true })
          : undefined,
        toDate: filterOption?.toDate
          ? formatUTCDate(filterOption?.toDate, { isEndOfDay: true })
          : undefined,
        lastSignedStartDate: filterOption?.lastSignedStartDate
          ? formatUTCDate(filterOption?.lastSignedStartDate, {
              isStarOfDay: true,
            })
          : undefined,
        lastSignedEndDate: filterOption?.lastSignedEndDate
          ? formatUTCDate(filterOption?.lastSignedEndDate, { isEndOfDay: true })
          : undefined,
        ...sortOption,
      });

      status === 200 && resultsReviewDispatcher.getDataSuccess(result);
    },
  getReviewById:
    (reviewId, callback) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(
        `fut-backrooms/reviews/${reviewId}`
      );
      if (status === 200) callback && callback(result);
    },
  resetData: () => ({}),
  getLinkDownloadBackroom:
    (paxScreeningId, moduleId, callback) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(
        `backrooms/${paxScreeningId}/results/${moduleId}`,
        undefined,
        undefined,
        false
      );
      console.log('result', result);
      if (status === 200) callback && callback(result);
    },

  updateIndividualTestReview:
    (reviewId, testId, data, callback) =>
    async ({ Api }) => {
      const { result, status } = await Api.put(
        `fut-backrooms/reviews/${reviewId}/tests/${testId}`,
        data
      );
      if (status === 200 || status === 204) callback && callback(result);
    },

  submitIndividualTestReview:
    (reviewId, testId, data, callback) =>
    async ({ Api }) => {
      const { result, status } = await Api.put(
        `fut-backrooms/reviews/${reviewId}/tests/${testId}`,
        { ...data, reviewStatus: 'Completed' }
      );
      if (status === 200 || status === 204) callback && callback(result);
    },
  submitAllReview:
    (params, reviewId, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post(
        `fut-backrooms/reviews/${reviewId}/save`,
        params
      );

      if (status === 200 || status === 204) callback && callback();
    },
  uploadBackroom:
    (id, data, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post(
        `backrooms/${id}/results`,
        data,
        '',
        undefined,
        true,
        true
      );

      if (status === 200) {
        callback && callback(true);
      }
    },
  setState: (state, value) => ({ state, value }),

  getExportExcel:
    (params) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(`fut-backrooms/export`, {
        ...params,

        fromDate: params?.fromDate
          ? formatUTCDate(params?.fromDate, { isStarOfDay: true })
          : undefined,
        toDate: params?.toDate
          ? formatUTCDate(params?.toDate, { isEndOfDay: true })
          : undefined,
        lastSignedStartDate: params?.lastSignedStartDate
          ? formatUTCDate(params?.lastSignedStartDate, { isStarOfDay: true })
          : undefined,
        lastSignedEndDate: params?.lastSignedEndDate
          ? formatUTCDate(params?.lastSignedEndDate, { isEndOfDay: true })
          : undefined,
      });
      const fileName = `Results_Review_List_${moment().format(
        FORMAT_DD_MM_YYYY
      )}`;

      status === 200 && createDownloadableLink(result, fileName);
    },
};

const resultsReviewDispatcher = synthesize(
  'resultsReviewBackroom',
  mapDispatchToAC
);

export default resultsReviewDispatcher;
